function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable no-cond-assign */
import Cookies from "js-cookie";
import { match } from "./path-to-regexp";
// const match = require('path-to-regexp');
/**
 * @description 获取序列化的userAgent对象
 * @returns {IBrowse}
 */
export function getUA() {
  var Sys = {};
  var ua = navigator.userAgent.toLowerCase();
  var s;
  if (s = ua.match(/ qq\/([\d.]+)/)) {
    Sys.qqBuildinBrowser = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/mqqbrowser\/([\d.]+)/)) {
    Sys.qqBrowser = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/opera.([\d.]+)/)) {
    Sys.opera = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/msie ([\d.]+)/)) {
    Sys.ie = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/edge.([\d.]+)/)) {
    Sys.edge = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/firefox\/([\d.]+)/)) {
    Sys.firefox = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/chrome\/([\d.]+)/)) {
    Sys.chrome = Number(s[1].split(".")[0]);
  } else if (s = ua.match(/version\/([\d.]+).*safari/)) {
    Sys.safari = Number(s[1].match(/^\d*.\d*/));
  } else if (s = ua.match(/trident\/([\d.]+)/)) {
    Sys.ie = 11;
  }
  return Sys;
}
/**
 * @description 获取 url ?后的参数
 * @param {string}
 * @returns {array}
 */
export var getUrlParam = function getUrlParam(href) {
  var name;
  var value;
  var str = href;
  var num = str.indexOf("?");
  str = str.substr(num + 1);
  var arr = str.split("&");
  var json = {};
  for (var i = 0; i < arr.length; i++) {
    num = arr[i].indexOf("=");
    if (num > 0) {
      name = arr[i].substring(0, num);
      value = arr[i].substr(num + 1);
      json[name] = value;
    }
  }
  return json;
};
/**
 * @description 去除 url ？#及后面的参数
 * @param {string}
 * @returns {string}
 */
export var urlExcludeArgs = function urlExcludeArgs(url) {
  var result = url;
  var searchIndex = url.indexOf("?");
  if (searchIndex !== -1) {
    result = result.slice(0, searchIndex);
  }
  var anchorIndex = url.indexOf("#");
  if (anchorIndex !== -1) {
    result = result.slice(0, anchorIndex);
  }
  return result;
};
/**
 * @description 根据白名单排除无用的参数
 * @param {string} url
 * @param {array} whiteList 参数白名单
 * @returns {string} url
 */
export var urlExcludeForWhiteList = function urlExcludeForWhiteList(url) {
  var whiteList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (url.indexOf("?") === -1) return url;
  var params = getUrlParam(url);
  var cleanUrl = urlExcludeArgs(url);
  try {
    for (var i = 0; i < whiteList.length; i++) {
      if ((params === null || params === void 0 ? void 0 : params[whiteList[i]]) !== undefined) {
        var prefix = cleanUrl.indexOf("?") === -1 ? "?" : "&";
        cleanUrl += "".concat(prefix).concat(whiteList[i], "=").concat(params === null || params === void 0 ? void 0 : params[whiteList[i]]);
      }
    }
  } catch (e) {
    return url;
  }
  return cleanUrl;
};
/**
 * @description 对象序列化为url参数
 * @param {Object} obj
 * @returns {string} url params
 */
export var stringifyParams = function stringifyParams(obj) {
  var keys = [];
  for (var _i = 0, _Object$entries = Object.entries(obj); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    keys.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)));
  }
  return keys.join("&");
};
/**
 * @description 根据xpath匹配对应的元素列表
 * @param {xpath} string
 */
export function getEl4xpath(xpath) {
  try {
    var pEl = document.evaluate(xpath, document, null, XPathResult.ANY_TYPE, null);
    var result = [];
    var dom = pEl.iterateNext();
    while (dom) {
      result.push(dom);
      dom = pEl.iterateNext();
    }
    return result;
  } catch (e) {
    return [];
  }
}
/**
 * @description sentry错误上报
 * @param {err} any
 */
export function sentryReport(err) {
  if (!window.sentry) {
    return;
  }
  window.sentry.configureScope(function (scope) {
    return scope.setTag("buriedPoint", err);
  });
  window.sentry.captureException(err, {
    tags: {
      section: "buriedPoint"
    }
  });
}
/**
 * @description 获取位置来源
 */
export function deviceSource() {
  var userAgent = window.navigator.userAgent;
  var isNewCarApp = userAgent.includes("newcar8891");
  var isUsedCarApp = userAgent.includes("car8891");
  var os;
  var system;
  if (isUsedCarApp) {
    if (/Android/.test(userAgent)) {
      os = "Android";
    } else {
      os = "iOS";
    }
    system = isUsedCarApp && isNewCarApp ? "newcar" : "usedcar";
  } else {
    os = "touch";
    system = "web";
  }
  return {
    os: os,
    system: system
  };
}
/**
 * @description 根据id用正则匹配页面path
 * @param {id} string
 * @returns {path} string
 */
export var isMatchLink = function isMatchLink(id, path) {
  var matchs = {};
  try {
    matchs = match(new RegExp(id))(path);
  } catch (e) {
    // console.log(e);
  }
  return matchs;
};
/**
 * @description 接口data中根据key获取对应的value
 *  @param {data} data
 *  @param {key}  data.user.msg.name ('张三')
 */
var _getElegantly = function getElegantly(data, key) {
  var newProps = key;
  if (typeof newProps === "string") {
    newProps = newProps.split(".");
  }
  if (newProps.length === 0) {
    return data;
  }
  var prop = newProps.shift();
  if (prop && data.hasOwnProperty(prop)) {
    return _getElegantly(data[prop], newProps);
  }
  // 错误上报
  sentryReport(data);
  return "";
};
/**
 * @description 根据 key 获取 url 参数数据
 * @param {string} key
 * @return {string} param
 */
export { _getElegantly as getElegantly };
export var getParamsForUrl = function getParamsForUrl(key) {
  var params = new URLSearchParams(location.search);
  return params.get(key) || "";
};
/**
 * @description 获取window上的用户自定义属性
 * @return {Array}
 */
export function getUserDefinedForWindow() {
  var results = [];
  var currentWindow;
  var iframe = document.createElement("iframe");
  if (!(document === null || document === void 0 ? void 0 : document.body)) return [];
  iframe.style.display = "none";
  document.body.appendChild(iframe);
  // eslint-disable-next-line prefer-const
  currentWindow = Object.getOwnPropertyNames(window);
  results = currentWindow.filter(function (prop) {
    var _a;
    return !((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(prop));
  });
  document.body.removeChild(iframe);
  return results;
}
/**
 * @description 当前Url是否有匹配中的pageRoute
 * @return {boolean}
 */
export function isPageRoute(_ref) {
  var pageRoute = _ref.pageRoute,
    pageId = _ref.pageId;
  // const isUrlXpath = isMatchLink(pageId, locationHref);
  var pageRouteSplit = pageId.split("|");
  var isRote = pageRouteSplit.includes(pageRoute);
  return isRote;
}
export function getValueByPath(path) {
  // 分割路径为键的数组
  var keys = path.split(".");
  // 从window对象开始
  var currentObject = window;
  // 遍历键数组
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      // 如果当前键在对象中不存在，则返回undefined
      if (currentObject[key] === undefined) {
        return undefined;
      }
      // 更新当前对象为下一个键所在的对象
      currentObject = currentObject[key];
    }
    // 返回找到的值
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return currentObject;
}
/**
 * @description 提取第一个点之后的字符串
 * @return {string}
 */
export var extractStringAfterFirstDot = function extractStringAfterFirstDot(str) {
  var parts = str.split(".");
  if (parts.length > 1) {
    return parts.slice(1).join(".");
  }
  return "";
};
/**
 * @description 获取当前页的点击事件和曝光事件
 * @return json[]
 */
export var getCurrentJson = function getCurrentJson(self, arr) {
  var currentJson = [];
  if (arr.length > 0) {
    arr.map(function (item) {
      var _item$trigger = item.trigger,
        page_id = _item$trigger.page_id,
        type = _item$trigger.type;
      var isUrlAndPageRoute = false;
      if (page_id !== "/") {
        isUrlAndPageRoute = isPageRoute({
          pageId: page_id,
          pageRoute: window === null || window === void 0 ? void 0 : window.page_route
        });
      }
      if (isUrlAndPageRoute || ["global_pageview", "global_exposure", "global_action"].includes(type)) {
        currentJson.push(item);
      }
    });
  }
  return currentJson;
};
/**
 * @description 初始化相关事件监听
 */
export var setCookieSpm = function setCookieSpm(self) {
  if (!!self.TRACK_LOCAL_STORAGE_NEXT_SPM) {
    var expirationTime = new Date();
    expirationTime.setTime(expirationTime.getTime() + 20 * 60 * 1000); // 20分钟后的时间
    Cookies.set("TRACK_LOCAL_STORAGE_NEXT_SPM", self.TRACK_LOCAL_STORAGE_NEXT_SPM, {
      expires: expirationTime,
      domain: ".8891.com.tw"
    });
  }
};
export function findCurrentParam(params, clickJson, exposuresJson) {
  var arr = [].concat(_toConsumableArray(clickJson), _toConsumableArray(exposuresJson));
  var sourceArr = [];
  // 过滤出 name 等于 params.name 的项，只取 event 对象
  arr.forEach(function (item) {
    var _a;
    if (item.event && ((_a = item.event) === null || _a === void 0 ? void 0 : _a.name) === (params === null || params === void 0 ? void 0 : params.name)) {
      sourceArr.push(item.event);
    }
  });
  // 只返回第一个匹配项的 params 对象
  var result = sourceArr.find(function (item) {
    var _a, _b;
    return (item === null || item === void 0 ? void 0 : item.params) && ((_a = item === null || item === void 0 ? void 0 : item.params) === null || _a === void 0 ? void 0 : _a.next_spm) === ((_b = params === null || params === void 0 ? void 0 : params.params) === null || _b === void 0 ? void 0 : _b.next_spm);
  });
  if (!result) return;
  var newParams = Object.assign(Object.assign({}, params === null || params === void 0 ? void 0 : params.params), result === null || result === void 0 ? void 0 : result.params);
  if (!!result) {
    result.params = newParams;
  }
  return result ? result : {};
}